import { useFieldArray, useForm } from "react-hook-form";
import cargoDetail from "../assets/images/worldwide-shipping.svg";
import LabeledTextField from "../mui-components/LabeledTextField";
import { Columns, Col12 } from "../Controls.js";
import { useSnapshot } from "valtio";
import { AgmodalStore, aguserStore, configStore, EntityV2Store } from "../state/CommonState";
import { useEffect, useRef, useState } from "react";
import { AgUnlocCH } from "../components/AgComponents.js";
import { getHazardousClassList } from "../StaticData.js";
import { ActiveTabCH } from "../v3-componets/AgActiveTab.js";

import { Cargo } from "../enquiry/enquiry-data";
import {
  lclWeightForPort,
  maxDimensions,
  packageTypeList,
  weightPerPackage,
} from "../StaticData";
import { Quantity } from "../tailwind-components/Quantity";
import { TextWithSelect } from "../mui-components/TextWithSelect";
import { AgMuiSelect2 } from "../mui-components/Controlled";
import deleteicon from "../assets/images/deletei.svg";
import Utils from "../util/Utils";
import { FlexibleCenteredDiv } from "../v3-componets/AgFlexibleCenteredDiv.js";
import { TableHeading } from "../v3-componets/AgTableHeading.js";
import { HeadingWithSelect } from "../v3-componets/AgHeadingWithSelect.js";
import { Add } from "@mui/icons-material";
import { DetailsText3 } from "../mui-components/DetailsText.js";
import { DetailsSelect2 } from "../mui-components/DetailsSelect.js";
import { ControlledDetailSwitch } from "../v3-componets/AgControlledDetailSwitch.js";
import { cartingStore } from "./cartingStore.js";
import { Headspan } from "../v3-componets/AgHeadspan.js";
import CartingOrderApi from "../state/cartingorder-api.js";
import { loader } from "../util/loader.js";
import { AgCustlistCH, AgSelectNewCH } from "../components/AgCustlist.js";
import { AgCustomFile } from "../components/AgFile.js";
import { $c } from '../components/AgComponents.js'
import AguserApi from "../state/AguserApi.js";
import EntityV2Api from "../state/entities-api.js";
import { Autocomplete, TextField, Typography,Grid, Box } from "@mui/material";
import { CustomStyledTextField } from "../mui-components/ColoredTextfield.js";

export default function CartingorderEdit() {
  const LabelStyle =
    "flex items-center justify-center border-l-[0.5px] border-l-solid border-l-[#D4D4D4] font-bold text-sm min-w-[24px] h-full";
  const DimensionLabelStyle = {
    height: "25px",
    width: "80px",
    padding: 0,
    fontSize: "13px",
  };
  useSnapshot(configStore);
  useSnapshot(cartingStore);
  useSnapshot(AgmodalStore);
  useSnapshot(EntityV2Store)
  useSnapshot(aguserStore);
  const [valid, setValid] = useState(true);
  const [selectedType, setType] = useState("LCL");
  const [mode, setMode] = useState("lcl");
  const [isDimension, setIsDimension] = useState(false);
  const ref = useRef(null);
  const [update, setUpdate] = useState(false);
  const [agActiveList, setAgActiveList] = useState([])
  const [inputValue, setInputValue] = useState("");
  const [selectedValue, setSelectedValue] = useState("");
  const [options, setOptions] = useState([]);
  const [total, setTotal] = useState({
    totNumPackages: 0,
    totTotalWeight: 0,
    totTotalVolume: 0,
    totChargeableWeight: 0,
  });
  const cargoForm = useForm({
    defaultValues: {
      mode: "LCL",
      invoiceDetails: [
        {
          invoiceNo: "",
          HSCode: "",
          marksNos: "",
          commodityType: "",
        },
      ],
      cargoDetails: [new Cargo()],
      cargoDimensionUnit: "Cms",
      hazardous: false,
      nonStackable:false
    },
  });
  const {
    control,
    watch,
    register,
    setValue,
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
    trigger,
    getFieldState,
    getValues,
  } = cargoForm;
  const onSubmit = (data) => {
    let kz = Object.keys(data)
    for (let i = 0; i < kz.length; i++) {
      console.log(kz[i],data[kz[i]])
      if(typeof data[kz[i]] === "string"){
        data[kz[i]] = data[kz[i]].trim()
        setValue(kz[i], data[kz[i]])
      }
    }
    let k1 = Object.keys(cartingStore.requiredlist);
    let v = true
    let l = ["portOfReceipt","portOfLoading","portOfDischarge","finalPlaceOfDelivery"]
    for (let i = 0; i < k1.length; i++) {
        if((k1[i]!='netWeight' && k1[i]!="reworkingPort" && l.indexOf(k1[i])==-1 && (data[k1[i]]==undefined || data[k1[i]].length==0)) ||
         (k1[i]=='netWeight' && (data[k1[i]]==undefined || Number(data[k1[i]])<1)) ||
        (l.indexOf(k1[i])!=-1 && !getvaild(k1[i],false)) || 
        (k1[i]=="reworkingPort" && !getvaild(k1[i],false,true))){
          v = false
          setValid(false)
      
      if(!v){
        switch(true){
          case k1[i]=='netWeight':
            configStore.setModalMessage(`Please Enter Net Weight minimum 1`);
            break;
          default:
            configStore.setModalMessage(`Please check the fields`);
        }
        i = k1.length+1
      }
      }
    }
    if(v){
      loader.show();
      let k = Object.keys(cartingStore.list);
      for (let i = 0; i < k.length; i++) {
        if(data[k[i]]!=undefined){
          cartingStore.current[k[i]] = data[k[i]];
        }
      }
      cartingStore.current["totalWeight"] = total.totTotalWeight
      cartingStore.current["totalNumPackages"] = total.totNumPackages
      cartingStore.current["totalVolume"] = total.totTotalVolume
      if(cartingStore.update==true){
        const callback = (d) => {
          loader.hide();
          if(d.message==undefined){
            cartingStore.current = JSON.parse(JSON.stringify(d));
            configStore.setModalMessage(`Updated successfully. Carting Sheet Ref No#:` + d["_id"],[],false);
            AgmodalStore.pageVisible = false;
            AgmodalStore.apiCall = true;
          }else{
            configStore.setModalMessage(d.message,[],false);
          }
        };
        CartingOrderApi.UpdateCartingorder(cartingStore.current, callback);
      }else{
        const callback = (d) => {
          console.log(d);
          loader.hide();
          cartingStore.current = JSON.parse(JSON.stringify(d));
          configStore.setModalMessage(`Carting Sheet Ref No#:` + d["_id"],[],false);
          AgmodalStore.pageVisible = false;
          AgmodalStore.apiCall = true;
        };
        CartingOrderApi.CreateCartingorder(cartingStore.current, callback);
      }
    }
  };
  const dimensionsUnit = watch("cargoDimensionUnit");
  const entityId = getValues('entityId')
  const weight = getValues(`cargoDetails.0.weight.unit`);
  let cargodetailsFromForm = watch(`cargoDetails`);
  const totalWeight = getValues(`cargoDetails.0.totalWeight.unit`);
  const totalVolume = getValues(`cargoDetails.0.totalVolume.unit`);
  const rsi =
    watch("remarks_special_instrctions") == undefined
      ? ""
      : watch("remarks_special_instrctions");

  const {
    fields: invoiceDetails,
    append: appendInvoice,
    remove: removeInvoice,
  } = useFieldArray({
    control: control,
    name: `invoiceDetails`,
  });

  const {
    fields: cargoDetails,
    append: appendCargo,
    remove: removeCargo,
  } = useFieldArray({
    control: control,
    name: `cargoDetails`,
  });
  const inovicede = watch("invoiceDetails");
  let hazardous = watch("hazardous");
  let reefer = watch("reefer");
  let overHeight = watch("overHeight");
  let overlength = watch("overlength");
  let topLoading = watch("topLoading");
  let fumigation = watch("fumigation");
  let headLoad = watch("headLoad");
  let doorLoad = watch("doorLoad");
  let nonStackable = watch("nonStackable")
  let nomination = watch("nomination")
  let bankInvolved = watch("bankInvolved")
  let consigneeName = watch("consigneeName")
  let portlist = [
    {
      label:"ICD Tughlakabad, India (INTKD)",
      value:"ICD Tughlakabad, India (INTKD)"
    },
    {
      label:"Ahmedabad, India (INAMD)",
      value:"Ahmedabad, India (INAMD)"
    },
    {
      label:"Bangalore, India (INBLR)",
      value:"Bangalore, India (INBLR)"
    },
    {
      label:"Hyderabad, India (INHYD)",
      value:"Hyderabad, India (INHYD)"
    },
    {
      label:"Nhava Sheva, India (INNSA)",
      value:"Nhava Sheva, India (INNSA)"
    }
  ]
  useEffect(()=>{
    if(bankInvolved && consigneeName!="TO THE ORDER OF"){
      setValue("consigneeName",'TO THE ORDER OF')
    }
    if(!bankInvolved && consigneeName=="TO THE ORDER OF"){
      setValue("consigneeName",'')
    }
  },[bankInvolved,consigneeName])

  const formValues = watch();
  const check = async () => {
    if (!valid) {
      await trigger();
    }
  };
  
 
  const handleSelectChange = (value) => {
    setSelectedValue(value);
    setValue("CFSLocation",value)
  };
  const handleInputChange = (value) => {
    setInputValue(value);
    setValue("CFSLocation",value)
  };
  useEffect(()=>{
    const callback = (data) =>{
      let d = data.filter(item => item.trim() !== "");
      if(JSON.stringify(options)!=JSON.stringify(d)){
        setOptions(d)
      }
    }
    CartingOrderApi.getCfslocations(callback)
  },[])
  useEffect(() => {
    check();
    console.log(formValues);
  }, [JSON.stringify(formValues)]);

  useEffect(() => {
    if (
      update == false &&
      cartingStore.current._id != undefined &&
      cartingStore.current._id.length > 0
    ) {
      setUpdate(false);
      loader.show();
      let k = Object.keys(cartingStore.list);
      setType(cartingStore.current['mode']);
      setMode(cartingStore.current['mode'].toLowerCase());
      for (let i = 0; i < k.length; i++) {
        setValue(k[i], cartingStore.current[k[i]]);
      }
      if(cartingStore.current["CFSLocation"]!=undefined && cartingStore.current["CFSLocation"]!=selectedValue){
        setSelectedValue(cartingStore.current["CFSLocation"])
      }
      loader.hide();
      setUpdate(true);
    } else {
      setUpdate(true);
    }
  }, [JSON.parse(JSON.stringify(cartingStore.current))]);

  const changeShipmentTypes = (type) => {
    if(!cartingStore.disable){
      setValue('mode',type)
      setType(type);
      setMode(type.toLowerCase());
      setValue("cargoDetails", [new Cargo()]);
    }
  };

  const calculateWeightAndVolume = () => {
    if (
      JSON.stringify({
        totNumPackages: 0,
        totTotalWeight: 0,
        totTotalVolume: 0,
        totChargeableWeight: 0,
      }) != JSON.stringify(total)
    ) {
      setTotal({
        totNumPackages: 0,
        totTotalWeight: 0,
        totTotalVolume: 0,
        totChargeableWeight: 0,
      });
    }
    if (getValues(`cargoDetails`) != undefined) {
      let totals = Utils.calcCargoDetails(
        getValues(`cargoDetails`),
        isDimension,
        dimensionsUnit,
        mode,
        cargodetailsFromForm[0]
      );
      setTotal({ ...totals });
      setValue("grandTotalWeight",totals.totTotalWeight)
            setValue("grandTotalVolume",totals.totTotalVolume)
            setValue("grandChargeable",totals.totChargeableWeight)
    }
  };

  useEffect(() => {
    calculateWeightAndVolume();
  }, [JSON.stringify(cargodetailsFromForm)]);
  useEffect(() => {
    setValue(`cargoDetails.0.totalWeight.unit`, weight);
    for (let i = 1; i < cargoDetails.length; i++) {
      setValue(`cargoDetails.${i}.weight.unit`, weight);
    }
    calculateWeightAndVolume();
  }, [weight]);

  useEffect(() => {
    for (let i = 1; i < cargoDetails.length; i++) {
      setValue(`cargoDetails.${i}.totalWeight.unit`, totalWeight);
    }
    calculateWeightAndVolume();
  }, [totalWeight]);

  useEffect(() => {
    for (let i = 1; i < cargoDetails.length; i++) {
      setValue(`cargoDetails.${i}.totalVolume.unit`, totalVolume);
    }
    calculateWeightAndVolume();
  }, [totalVolume]);

  useEffect(() => {
    calculateWeightAndVolume();
  }, [dimensionsUnit]);

  const validateGreaterThanZero = (value) => {
    return parseFloat(value) > 0 || "Required";
  };
  useEffect(() => {
    calculateWeightAndVolume();
  }, [isDimension]);
    const filecat = '' + Date.now()
  const delFile = (a,ind)=>{
        let l = []
        for (let i = 0; i < a.length; i++) {
            if(i!=ind){
                l.push(a[i])
            }
        }
        return l
    }
const renderLink = (fileName) => {
        if (fileName && fileName.length > 3) {
            return (
                <a href={process.env.REACT_APP_FILE_SERVER + '/clientfiles/' + fileName} target="_blank">{fileName}</a>
            )
        } else return <></>
    }

  const getvaild = (name, ch=true, rw=false) =>{
    if(!valid || !ch){
      if(!rw && (formValues[name]==undefined || formValues[name].length==0)){
        return false
      }else if(rw && (formValues[name]==undefined || formValues[name].length==0)){
          return true
      }else{
        return cartingStore.validation[name]
      }
    }else{
      return true
    }
  }

  useEffect(()=>{
      const agactiveuserlist = () =>{
        let l = []
        for (let i = 0; i < aguserStore.list.length; i++) {
          let e = aguserStore.list[i]
          if(e['status']=="ACTIVE" && e['email'].indexOf(`@${process.env.REACT_APP_ENTERPRISE_DOMAIN}`)!=-1){
            l.push(
              {
                label:aguserStore.getName4email(e['email']),
                value:aguserStore.getName4email(e['email'])
              }
            )
          }
        }
        if(JSON.stringify(agActiveList)!=JSON.stringify(l)){
          setAgActiveList(l)
        }
      }
      agactiveuserlist()
    },[aguserStore.list])
    useEffect(() => {
      AguserApi.getList();
    }, []);

    useEffect(() => {
        getEntityData()
        console.log("cartingStore.current",cartingStore.current,entityId);
      }, [entityId])
      const getEntityData = async ()=>{  
        console.log("cartingStore.current",cartingStore.current,entityId);
        if (!entityId) {
          return ""
        }
        let entity =  await EntityV2Api.viewEntity(entityId)
        console.warn("FOUND ENTITY = ", entity);
        if (entity) {
          if(cartingStore.current.salesperson==undefined || (cartingStore.current.salesperson!=undefined && cartingStore.current.salesperson.length==0)){
            let email = entity?.customer?.crossBorder?.relationshipManager;
            if(email){
              let e = aguserStore.getName4email(email)
              cartingStore.current.salesperson = e;
              setValue('salesperson',e)
            }else {
              cartingStore.current.salesperson = "";
              setValue('salesperson',"")
            }
          }
          if(cartingStore.current.customerService==undefined || (cartingStore.current.customerService!=undefined && cartingStore.current.customerService.length==0)){
      let email = entity?.customer?.crossBorder?.customerService;
                    if (email){
                      let e = aguserStore.getName4email(email)
                  cartingStore.current.customerService = e;
                  setValue('customerService',e)
                    }else {
                  cartingStore.current.customerService = "";
                  setValue('customerService',"")
                }
          }
          
        }
      }

      const generateId = (id,i)=> {
        if(id==undefined){
            let a = i + Date.now() + '-' + Math.floor(Math.random() * 1000)
            cargodetailsFromForm[i].id = a
            return a
        }else{
            return id
        }
    }

  return (
    <>
      {EntityV2Store.Cuslist!=undefined && EntityV2Store.Cuslist.length>0 && update && (
        <>
          <div class="mb-2 mt-2">
            <Headspan
              color="#555555"
              fontSize="20px"
              fontWeight="700"
              data={
                cartingStore.current._id != undefined &&
                cartingStore.current._id.length > 0
                  ? "Carting Sheet Ref. No# "
                  : "Carting Sheet"
              }
            />
            {cartingStore.current._id != undefined &&
            cartingStore.current._id.length > 0 ? (
              <Headspan
                color={process.env.REACT_APP_ENTERPRISE_COLOUR}
                fontSize="20px"
                fontWeight="700"
                data={cartingStore.current._id}
              />
            ) : (
              ""
            )}
          </div>
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-[10px]">
                <img src={cargoDetail} />
                <p className="text-black font-bold">Shipping Details</p>
              </div>
              <div className="flex flex-row gap-[10px]">
                <ControlledDetailSwitch
                  control={control}
                  isChecked={nomination}
                  register={register}
                  formKey={"nomination"}
                  title={"Nomination"}
                  disable={cartingStore.disable}
                />
              </div>
              <div className="flex flex-row gap-[10px]">
                <ControlledDetailSwitch
                  control={control}
                  isChecked={bankInvolved}
                  register={register}
                  formKey={"bankInvolved"}
                  title={"Bank Involved"}
                  disable={cartingStore.disable}
                />
              </div>
            </div>
            <div className="columns is-vcentered is-multiline qoutecard">
              {[
                {
                  lable: "Shipper Name",
                  type: "string",
                  name: "shipperName",
                  rules:{ required: "Required" }
                },
                {
                  lable: "Address",
                  type: "string",
                  name: "address",
                  rules:{ required: "Required" }
                },
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      rules={e.rules}
                      disabled={cartingStore.disable && !cartingStore.update}
                    />
                  </div>
                );
              })}
              {[
                {
                  lable: "IEC Code",
                  type: "string",
                  name: "IECCode",
                  rules:{}
                },
                {
                  lable: "Shipping Bill No",
                  type: "string",
                  name: "shippingBillNo",
                  rules:{ required: "Required" }
                },
                {
                  lable: "Shipping Bill Date",
                  type: "date",
                  name: "shippingBillDate",
                  rules:{ required: "Required" }
                },
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      rules={e.rules}
                      disabled={cartingStore.disable}
                    />
                  </div>
                );
              })}
              {[
                {
                  lable: "Leo Date & Time",
                  type: "datetime-local",
                  name: "LeoDateTime",
                  rules:{}
                },
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      rules={e.rules}
                      disabled={cartingStore.disable && !cartingStore.update}
                    />
                  </div>
                );
              })}
              </div>
              {/* <div className="columns is-vcentered is-multiline qoutecard">
              {inovicede.map((e, i) => {
                return (
                  <>
                    <div className="column is-3">
                      <LabeledTextField
                        key={e.id}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.invoiceNo`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="Invoice No"
                        control={control}
                        name={`invoiceDetails.${i}.invoiceNo`}
                        size="small"
                        fullWidth
                        rules={{ required: "Required" }}
                      />
                    </div>
                    <div className="column is-3">
                      <LabeledTextField
                        key={e.id}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.marksNos`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="Marks & Nos"
                        control={control}
                        name={`invoiceDetails.${i}.marksNos`}
                        size="small"
                        fullWidth
                        rules={{ required: "Required" }}
                      />
                    </div>
                    <div className="column is-3">
                      <LabeledTextField
                        key={e.id}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.HSCode`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="HS Code"
                        control={control}
                        name={`invoiceDetails.${i}.HSCode`}
                        size="small"
                        fullWidth
                        rules={{ required: "Required" }}
                      />
                    </div>
                    <div className="column is-2">
                      <AgSelectCA
                        label="Commodity Type"
                        name="commodityType"
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.commodityType`, e1);
                        }}
                        value={e.commodityType}
                        dataList={commodityList}
                      />
                    </div>
                    <div className="column is-1">
                      <p style={{ paddingTop: "20%", textAlign: "center" }}>
                        {inovicede.length == i + 1 ? (
                          <button
                            className="button is-success is-inverted"
                            onClick={() => {
                              appendInvoice({
                                ...{
                                  invoiceNo: "",
                                  HSCode: "",
                                  marksNos: "",
                                  commodityType: "",
                                },
                              });
                            }}
                          >
                            <span className="icon is-small">
                              <i className="fas fa-plus"></i>
                            </span>
                          </button>
                        ) : (
                          <button
                            className="button is-danger is-inverted"
                            onClick={() => {
                              removeInvoice(i);
                            }}
                          >
                            <span className="icon">
                              <i className="fas fa-trash"></i>
                            </span>
                          </button>
                        )}
                      </p>
                    </div>
                  </>
                );
              })}
            </div> */}
          </div>
          <hr />
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-[10px]">
                <img src={cargoDetail} />
                <p className="text-black font-bold">Invoice Details</p>
              </div>
            </div>
              <div className="columns is-vcentered is-multiline qoutecard">
              {inovicede.map((e, i) => {
                return (
                  <>
                    <div className="column is-3">
                      <LabeledTextField
                        key={e.id}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.invoiceNo`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="Invoice No"
                        control={control}
                        name={`invoiceDetails.${i}.invoiceNo`}
                        size="small"
                        fullWidth
                        disabled={cartingStore.disable}
                      />
                    </div>
                    <div className="column is-3">
                      <LabeledTextField
                        key={e.id}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.marksNos`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="Marks & Nos"
                        control={control}
                        name={`invoiceDetails.${i}.marksNos`}
                        size="small"
                        fullWidth
                        disabled={cartingStore.disable}
                      />
                    </div>
                    <div className="column is-3">
                      <LabeledTextField
                        key={e.id}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.HSCode`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="HS Code"
                        control={control}
                        name={`invoiceDetails.${i}.HSCode`}
                        size="small"
                        fullWidth
                        disabled={cartingStore.disable}
                      />
                    </div>
                    <div className="column is-2">
                      <LabeledTextField
                        key={e.id}
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.commodityType`, e1);
                        }}
                        labelStyle={{
                          fontSize: "12px",
                          color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                          fontWeight: "bold",
                        }}
                        label="Commodity Type"
                        control={control}
                        name={`invoiceDetails.${i}.commodityType`}
                        size="small"
                        fullWidth
                        disabled={cartingStore.disable}
                      />
                      {/* <AgSelectCA
                        label="Commodity Type"
                        name="commodityType"
                        callback={(e1) => {
                          setValue(`invoiceDetails.${i}.commodityType`, e1);
                        }}
                        value={e.commodityType}
                        dataList={commodityList}
                      /> */}
                    </div>
                    {cartingStore.disable==false && <div className="column is-1">
                      <p style={{ paddingTop: "20%", textAlign: "center" }}>
                        {inovicede.length == i + 1 ? (
                          <button
                            className="button is-success is-inverted"
                            onClick={() => {
                              appendInvoice({
                                ...{
                                  invoiceNo: "",
                                  HSCode: "",
                                  marksNos: "",
                                  commodityType: "",
                                },
                              });
                            }}
                          >
                            <span className="icon is-small">
                              <i className="fas fa-plus"></i>
                            </span>
                          </button>
                        ) : (
                          <button
                            className="button is-danger is-inverted"
                            onClick={() => {
                              removeInvoice(i);
                            }}
                          >
                            <span className="icon">
                              <i className="fas fa-trash"></i>
                            </span>
                          </button>
                        )}
                      </p>
                    </div>}
                  </>
                );
              })}
            </div>
          </div>
          <hr />
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-[10px]">
                <img src={cargoDetail} />
                <p className="text-black font-bold">Parties Involved</p>
              </div>
            </div>
            <div className="columns is-vcentered is-multiline qoutecard">
              {[
                {
                  lable: "Consignee Name",
                  type: "string",
                  name: "consigneeName",
                },
                {
                  lable: "Consignee Address",
                  type: "string",
                  name: "consigneeAddress",
                },
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      rules={{ required: "Required" }}
                      disabled={cartingStore.disable && !cartingStore.update}
                    />
                  </div>
                );
              })}
              {[
                {
                  lable: "CHA Name",
                  type: "string",
                  name: "CHAName",
                },
                {
                  lable: "CHA Number",
                  type: "string",
                  name: "CHANumber",
                },
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      rules={{ required: "Required" }}
                      disabled={cartingStore.disable}
                    />
                  </div>
                );
              })}
              <div className="column is-3">
                <AgCustlistCH
                  label="Customer Name"
                  name="entityId"
                  dataList={EntityV2Store.Cuslist}
                  callback={(e1) => {
                    cartingStore.current.salesperson = ""
                    cartingStore.current.customerService = ""
                    setValue(`entityId`, e1);
                  }}
                  value={formValues["entityId"]}
                  isDisabled={{disabled:cartingStore.disable}}
                />
              </div>
              <div className="column is-3">
                <AgSelectNewCH
                isDisabled={{disabled:cartingStore.disable}}
                  label="Relationship Manager"
                  name="salesperson"
                  dataList={agActiveList}
                  callback={(e1) => {
                    cartingStore.current.salesperson = e1
                    setValue(`salesperson`, e1);
                  }}
                  value={formValues["salesperson"]}
                />
              </div>
              <div className="column is-3">
                <AgSelectNewCH
                isDisabled={{disabled:cartingStore.disable}}
                  label="Customer Service"
                  name="customerService"
                  dataList={agActiveList}
                  callback={(e1) => {
                    cartingStore.current.customerService = e1
                    setValue(`customerService`, e1);
                  }}
                  value={formValues["customerService"]}
                />
              </div>
            </div>
          </div>
          <hr />
          {/* <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-[10px]">
                <img src={cargoDetail} />
                <p className="text-black font-bold">Route Details</p>
              </div>
              <div className="flex flex-row gap-[10px]">
                <ActiveTabCH
                  callback={changeShipmentTypes}
                  selectedType={selectedType}
                />
              </div>
            </div>
            <div className="columns is-vcentered is-multiline qoutecard">
              <div className="column is-3">
                <AgUnlocCH
                  shipmentType={selectedType}
                  label="Origin"
                  name="origin"
                  callback={(e1) => {
                    setValue(`origin`, e1);
                  }}
                  value={formValues["origin"]}
                />
              </div>
              <div className="column is-3">
                <AgUnlocCH
                  shipmentType={selectedType}
                  label="Destination"
                  name="destination"
                  callback={(e1) => {
                    setValue(`destination`, e1);
                  }}
                  value={formValues["destination"]}
                />
              </div>
            </div>
          </div>
          <hr /> */}
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-[10px]">
                <img src={cargoDetail} />
                <p className="text-black font-bold">Port Details</p>
              </div>
              <div className="flex flex-row gap-[10px]">
                <ActiveTabCH
                  callback={changeShipmentTypes}
                  selectedType={selectedType}
                />
              </div>
            </div>
            <div className="columns is-vcentered is-multiline qoutecard">
              <div className="column is-3">
                 <Box sx={{  width:"100%",height:"100%",gap:0 }}>
                  <Grid container rowSpacing={"4px"}>
                    <Grid item xs={12}>
                            <Typography variant="body1" style={{textAlign:"start",fontFamily:"Figtree",fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",}}>
        CFS Location
      </Typography>
                            </Grid>
                            <Grid item xs={12}>
<Autocomplete
        value={selectedValue}
        onChange={(event, newValue) => handleSelectChange(newValue)}
        inputValue={inputValue}
        size="small"
        onInputChange={(event, newInputValue) => handleInputChange(newInputValue)}
        options={options}
        disabled={cartingStore.disable || cartingStore.update}
        freeSolo
        
        renderInput={(params) => (
          <CustomStyledTextField sx={{ "& .MuiOutlinedInput-root": {
                    "&.Mui-focused": {
                      fieldset: {
                        borderColor:`${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`, // Default focused color
                      },
                    },
                  }}}   size="small"    {...params} fullWidth error={!valid && (formValues['CFSLocation']==undefined || formValues['CFSLocation'].length==0)} helperText={(!valid && (formValues['CFSLocation']==undefined || formValues['CFSLocation'].length==0))?"Required":""}/>
        )}
      />
                            </Grid>
                  </Grid>
                  
      
    </Box>
</div>
              {[
                {
                  lable: "SHED Location",
                  type: "string",
                  name: "SHEDLocation",
                  rules:{}
                }
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      rules={e.rules}
                      disabled={cartingStore.disable}
                    />
                  </div>
                );
              })}
              <div className="column is-3">
                <AgSelectNewCH
                isDisabled={{disabled:cartingStore.disable}}
                  label="Carted At"
                  name="portOfReceipt"
                  dataList={portlist}
                  callback={(e1) => {
                    setValue(`portOfReceipt`, e1);
                  }}
                  value={formValues["portOfReceipt"]}
                  isValid={getvaild('portOfReceipt')}
                  validationMsg={"* Please select an UN location"}
                />
              </div>
              <div className="column is-3">
                <AgUnlocCH
                isDisabled= {cartingStore.disable}
                  shipmentType={selectedType}
                  label="POL"
                  name="portOfLoading"
                  callback={(e1) => {
                    setValue(`portOfLoading`, e1);
                  }}
                  callback2={(e1,list) => {
                    cartingStore.validation.portOfLoading = list.some(ele => ele === e1);
                  }}
                  value={formValues["portOfLoading"]}
                  isValid={getvaild('portOfLoading')}
                />
              </div>
              {
                (selectedType.toLowerCase()=='lcl')?<div className="column is-3">
                <AgUnlocCH
                isDisabled= {cartingStore.disable}
                  shipmentType={selectedType}
                  label="Routing"
                  name="reworkingPort"
                  callback={(e1) => {
                    setValue(`reworkingPort`, e1);
                  }}
                  callback2={(e1,list) => {
                    cartingStore.validation.reworkingPort = list.some(ele => ele === e1);
                  }}
                  value={formValues["reworkingPort"]}
                  isValid={getvaild('reworkingPort',true,true)}
                  />
              </div>:""
              }
              <div className="column is-3">
                <AgUnlocCH
                isDisabled= {cartingStore.disable}
                  shipmentType={selectedType}
                  label="POD"
                  name="portOfDischarge"
                  callback={(e1) => {
                    setValue(`portOfDischarge`, e1);
                  }}
                  callback2={(e1,list) => {
                    cartingStore.validation.portOfDischarge = list.some(ele => ele === e1);
                  }}
                  value={formValues["portOfDischarge"]}
                  isValid={getvaild('portOfDischarge')}
                />
              </div>
              <div className="column is-3">
                <AgUnlocCH
                isDisabled= {cartingStore.disable}
                  shipmentType={selectedType}
                  label="FPOD"
                  name="finalPlaceOfDelivery"
                  callback={(e1) => {
                    setValue(`finalPlaceOfDelivery`, e1);
                  }}
                  callback2={(e1,list) => {
                    cartingStore.validation.finalPlaceOfDelivery = list.some(ele => ele === e1);
                  }}
                  value={formValues["finalPlaceOfDelivery"]}
                  isValid={getvaild('finalPlaceOfDelivery')}
                />
              </div>
              
              
              {(formValues["portOfReceipt"]!=undefined && formValues["portOfReceipt"].length>0 &&
                formValues["portOfLoading"]!=undefined && formValues["portOfLoading"].length>0 &&
                formValues["portOfReceipt"]!=formValues["portOfLoading"]
              ) && [
                {
                  lable: "ETA@POL",
                  type: "date",
                  name: "eta_at_pol",
                }
              ].map((e) => {
                return (
                  <div className="column is-3">
                    <LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label={e.lable}
                      control={control}
                      name={e.name}
                      type={e.type}
                      size="small"
                      fullWidth
                      disabled={cartingStore.disable}
                    />
                  </div>
                );
              })}
              
            </div>
          </div>
          <hr />
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-[10px]">
                <img src={cargoDetail} />
                <p className="text-black font-bold">Cargo Details</p>
              </div>
            </div>
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-[10px]">
<LabeledTextField
                      labelStyle={{
                        fontSize: "12px",
                        color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                        fontWeight: "bold",
                      }}
                      label="Net Weight(Kgs)"
                      control={control}
                      name="netWeight"
                      type="number"
                      size="small"
                      fullWidth
                      rules={{ required: "Required" }}
                      disabled={cartingStore.disable && !cartingStore.update}
                    />
              </div>
            </div>
            
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-[10px]">
                <ControlledDetailSwitch
                  control={control}
                  isChecked={reefer}
                  register={register}
                  formKey={"reefer"}
                  title={"Reefer"}
                  disable = {cartingStore.disable}
                />
              </div>
              <div className="flex flex-row gap-[10px]">
                <ControlledDetailSwitch
                  control={control}
                  isChecked={overHeight}
                  register={register}
                  formKey={"overHeight"}
                  title={"Over Height"}
                  disable = {cartingStore.disable}
                />
              </div>
              <div className="flex flex-row gap-[10px]">
                <ControlledDetailSwitch
                  control={control}
                  isChecked={overlength}
                  register={register}
                  formKey={"overlength"}
                  title={"Over length"}
                  disable = {cartingStore.disable}
                />
              </div>
              <div className="flex flex-row gap-[10px]">
                <ControlledDetailSwitch
                  control={control}
                  isChecked={topLoading}
                  register={register}
                  formKey={"topLoading"}
                  title={"Top Loading"}
                  disable = {cartingStore.disable}
                />
              </div>
              <div className="flex flex-row gap-[10px]">
                <ControlledDetailSwitch
                  control={control}
                  isChecked={fumigation}
                  register={register}
                  formKey={"fumigation"}
                  title={"Fumigation"}
                  disable = {cartingStore.disable}
                />
              </div>
                <div className="flex flex-row gap-[10px]">
                <ControlledDetailSwitch
                  control={control}
                  isChecked={headLoad}
                  register={register}
                  formKey={"headLoad"}
                  title={"Head Load"}
                  disable = {cartingStore.disable}
                />
                </div>
                <div className="flex flex-row gap-[10px]">
                  <ControlledDetailSwitch
                  control={control}
                  isChecked={doorLoad}
                  register={register}
                  formKey={"doorLoad"}
                  title={"Door Load"}
                  disable = {cartingStore.disable}
                />
                </div>
              <div className="flex flex-row gap-[10px]">
                <ControlledDetailSwitch
                  control={control}
                  isChecked={hazardous}
                  register={register}
                  formKey={"hazardous"}
                  title={"Hazardous"}
                  disable = {cartingStore.disable}
                />
              </div>
              <div className="flex flex-row gap-[10px]">
              <ControlledDetailSwitch disable = {cartingStore.disable} control={control} isChecked={nonStackable} formKey={"nonStackable"} title={"Non-Stackable"}/> 
              </div>
            </div>
            <div className="w-full flex flex-row justify-between flex-wrap gap-2.5">
              {hazardous && (
                <DetailsSelect2
                  control={control}
                  name={"quoteClass"}
                  label="Class"
                  options={getHazardousClassList(mode.toUpperCase())}
                  disabled={cartingStore.disable}
                />
              )}
              {hazardous && (
                <DetailsText3
                disabled={cartingStore.disable}
                  label={"UN Number"}
                  fontSize="12px"
                  size="small"
                  fullwidth
                  control={control}
                  name={"unnumber"}
                  rules={{
                    validate: (value) => {
                      if (value?.length != 4) {
                        return "UN number must be 4 numbers";
                      }
                    },
                  }}
                />
              )}
              {overHeight && (
                <DetailsText3
                disabled={cartingStore.disable}
                  label={"Over Height"}
                  fontSize="12px"
                  size="small"
                  fullwidth
                  control={control}
                  name={"overHeightValue"}
                />
              )}
              {overlength && (
                <DetailsText3
                disabled={cartingStore.disable}
                  label={"Over length"}
                  fontSize="12px"
                  size="small"
                  fullwidth
                  control={control}
                  name={"overlengthValue"}
                />
              )}
            </div>
            <div className="w-full flex flex-col gap-2 items-end">
              <div
                className={`flex flex-row w-full h-[35px] items-center border-[0.5px] border-solid border-[#D4D4D4] border-b-0 px-[12px]`}
              >
                <FlexibleCenteredDiv>
                  <TableHeading title="Package Type*" />
                </FlexibleCenteredDiv>
                <FlexibleCenteredDiv>
                  {" "}
                  <TableHeading title="Quantity *" />
                </FlexibleCenteredDiv>
                <FlexibleCenteredDiv>
                  <HeadingWithSelect
                  disabled={cartingStore.disable && !cartingStore.update}
                    onDropdownChange={() => {
                      //calculateWeightAndVolume();
                    }}
                    heading={
                      isDimension
                        ? mode === "lcl"
                          ? "Weight per package *"
                          : "Weight Per Piece *"
                        : "Total Weight *"
                    }
                    options={["Kgs", "Tons", "Lbs"]}
                    name={`cargoDetails.0.weight.unit`}
                    control={control}
                  />
                  {/* <TableHeading title={ (isDimension)? mode === "lcl" ? "Weight per package *" : "Weight Per Piece *" : "Total Weight *"} /> */}
                </FlexibleCenteredDiv>
                <div className={`flex flex-col flex-1`}>
                  {isDimension ? (
                    <div className="flex flex-row items-center justify-center w-[300px] gap-1 flex-1 ">
                      <TableHeading title="Dimensions* x" />
                      <AgMuiSelect2
                      disabled={cartingStore.disable && !cartingStore.update}
                        onChangeHandler={async () => {
                          //calculateWeightAndVolume();
                        }}
                        padding={0}
                        control={control}
                        name={"cargoDimensionUnit"}
                        size="small"
                        variant="standard"
                        disableUnderline={true}
                        values={["Cms", "MM", "Inches", "Meters", "Feet"]}
                        options={["Cms", "MM", "Inches", "Meters", "Feet"]}
                        fontColor="#555555"
                        iconColor="#555555"
                        style={{
                          fontSize: "12px",
                          alignItems: "center",
                          height: "25px",
                          // minWidth:"68px",
                          fontSize: "13px",
                          fontWeight: "bold",
                          color: "#555555",
                          borderLeft: 0,
                          padding: 0,
                          // paddingRight: "8px",
                          backgroundColor: "white",
                        }}
                      />
                    </div>
                  ) : (
                    <FlexibleCenteredDiv>
                      <HeadingWithSelect
                      disabled={cartingStore.disable && !cartingStore.update}
                        onDropdownChange={() => {
                          calculateWeightAndVolume();
                        }}
                        control={control}
                        name={`cargoDetails.0.totalVolume.unit`}
                        options={["CBM", "cu ft"]}
                        heading={"Total Volume*"}
                      />
                    </FlexibleCenteredDiv>
                  )}
                </div>
                {cargodetailsFromForm.length > 1 && (
                  <div className="w-[35px] h-full"></div>
                )}
              </div>
              {cargodetailsFromForm.map((cargodetail, i) => (
                <div
                  className={`flex flex-row w-full py-[8px] items-center px-[12px] ${
                    i % 2 === 0
                      ? "bg-[#F3F3F3]"
                      : "bg-white border-[0.5px] border-solid border-[#D4D4D4]"
                  }`}
                >
                  <FlexibleCenteredDiv>
                    <AgMuiSelect2
                    disabled={cartingStore.disable && !cartingStore.update}
                      getValues={getValues}
                      key={generateId(cargodetail.id,i)}
                      style={{ height: "25px", width: "170px" }}
                      onChangeHandler={(value) => {}}
                      onBlur={() => {}}
                      rules={{ required: "Required" }}
                      size="small"
                      fontSize="12px"
                      options={packageTypeList}
                      control={control}
                      name={`cargoDetails.${i}.packageType`}
                    />
                  </FlexibleCenteredDiv>
                  <FlexibleCenteredDiv>
                    <Quantity
                    disabled={cartingStore.disable && !cartingStore.update}
                      onChange={() => {}}
                      getValues={getValues}
                      key={generateId(cargodetail.id,i)}
                      callback={(e) => {
                        setValue(`cargoDetails.${i}.quantity`, e);
                      }}
                      control={control}
                      name={`cargoDetails.${i}.quantity`}
                      rules={{
                        required: "Required",
                        validate: validateGreaterThanZero,
                      }}
                    />
                  </FlexibleCenteredDiv>
                  <FlexibleCenteredDiv>
                    {isDimension ? (
                      <TextWithSelect
                      disabled={cartingStore.disable && !cartingStore.update}
                        onChange={() => {}}
                        getValues={getValues}
                        key={generateId(cargodetail.id,i)}
                        name={`cargoDetails.${i}.weight.value`}
                        control={control}
                        unit={mode === "air" ? weight : totalWeight}
                        rules={{
                          required: "Required",
                          validate: (value) => {
                            let isValue = validateGreaterThanZero(value);
                            if (typeof isValue === "string") {
                              return isValue;
                            } else if (mode !== "fcl") {
                              return;
                              let unit = getValues(
                                `cargoDetails.0.weight.unit`
                              );

                              let maxValue =
                                weightPerPackage[mode][unit.toLowerCase()];
                              if (parseFloat(value) > maxValue) {
                                // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                return `value can't be greater than ${
                                  maxValue + " " + unit
                                } `;
                              }
                            }
                          },
                        }}
                      />
                    ) : (
                      <TextWithSelect
                      disabled={cartingStore.disable && !cartingStore.update}
                        onChange={() => {}}
                        getValues={getValues}
                        unit={totalWeight}
                        key={generateId(cargodetail.id,i)}
                        options={["Kgs", "Tons", "Lbs"]}
                        control={control}
                        name={`cargoDetails.${i}.totalWeight.value`}
                        selectName={`cargoDetails.0.totalWeight.unit`}
                        rules={{
                          required: "Required",
                          validate: (value) => {
                            let isValue = validateGreaterThanZero(value);
                            const totalWeight = getValues(
                              `cargoDetails.0.totalWeight.unit`
                            );
                            if (typeof isValue === "string") {
                              return isValue;
                            } else if (mode !== "fcl") {
                              return;
                              let l = Utils.toNum(cargodetail.quantity);
                              if (l > 0) {
                                let maxValue =
                                  l *
                                  weightPerPackage[mode][
                                    totalWeight.toLowerCase()
                                  ];
                                if (parseFloat(value) > maxValue) {
                                  // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                  return `value can't be greater than ${
                                    maxValue + " " + totalWeight
                                  } `;
                                }
                              }
                            }
                          },
                        }}
                      />
                    )}
                  </FlexibleCenteredDiv>
                  {isDimension ? (
                    <FlexibleCenteredDiv className={`flex-none w-[300px]`}>
                      <div
                        key={generateId(cargodetail.id,i)}
                        className="flex flex-row w-full gap-1"
                      >
                        <LabeledTextField
                        disabled={cartingStore.disable}
                          onChange={() => {}}
                          textfieldStyles={DimensionLabelStyle}
                          rules={{
                            required: "Required",
                            validate: (value) => {
                              let isValue = validateGreaterThanZero(value);
                              if (typeof isValue === "string") {
                                return isValue;
                              } else if (mode !== "fcl") {
                                return;
                                let maxValue =
                                  maxDimensions[mode][
                                    dimensionsUnit.toLowerCase()
                                  ].length;

                                if (value > maxValue) {
                                  // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                  return `value can't be greater than ${
                                    maxValue + " " + dimensionsUnit
                                  } `;
                                }
                              }
                            },
                          }}
                          control={control}
                          name={`cargoDetails.${i}.dimensions.length`}
                          endAdornment={<div className={LabelStyle}>L</div>}
                        />
                        <p>x</p>
                        <LabeledTextField
                        disabled={cartingStore.disable}
                          onChange={() => {}}
                          textfieldStyles={DimensionLabelStyle}
                          rules={{
                            required: "Required",
                            validate: (value) => {
                              let isValue = validateGreaterThanZero(value);
                              if (typeof isValue === "string") {
                                return isValue;
                              } else if (mode !== "fcl") {
                                return;
                                let maxValue =
                                  maxDimensions[mode][
                                    dimensionsUnit.toLowerCase()
                                  ].width;

                                if (value > maxValue) {
                                  // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                  return `value can't be greater than ${
                                    maxValue + " " + dimensionsUnit
                                  } `;
                                }
                              }
                            },
                          }}
                          control={control}
                          name={`cargoDetails.${i}.dimensions.width`}
                          endAdornment={<div className={LabelStyle}>W</div>}
                        />
                        <p>x</p>
                        <LabeledTextField
                        disabled={cartingStore.disable}
                          onChange={() => {}}
                          textfieldStyles={DimensionLabelStyle}
                          rules={{
                            required: "Required",
                            validate: (value) => {
                              let isValue = validateGreaterThanZero(value);
                              if (typeof isValue === "string") {
                                return isValue;
                              } else if (mode !== "fcl") {
                                return
                                let maxValue =
                                  maxDimensions[mode][
                                    dimensionsUnit.toLowerCase()
                                  ].height;

                                if (value > maxValue) {
                                  // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                  return `value can't be greater than ${
                                    maxValue + " " + dimensionsUnit
                                  } `;
                                }
                              }
                            },
                          }}
                          control={control}
                          name={`cargoDetails.${i}.dimensions.height`}
                          endAdornment={<div className={LabelStyle}>H</div>}
                        />
                      </div>{" "}
                    </FlexibleCenteredDiv>
                  ) : (
                    <FlexibleCenteredDiv>
                      {" "}
                      <TextWithSelect
                      disabled={cartingStore.disable && !cartingStore.update}
                        onChange={() => {}}
                        getValues={getValues}
                        unit={totalVolume}
                        key={generateId(cargodetail.id,i)}
                        options={["CBM", "cu ft"]}
                        rules={{
                          required: "Required",
                          validate: (value) => {
                            let isValue = validateGreaterThanZero(value);
                            const totalVolume = getValues(
                              `cargoDetails.0.totalVolume.unit`
                            );
                            if (typeof isValue === "string") {
                              return isValue;
                            } else if (mode !== "fcl") {
                              return;
                              let maxValue =
                                lclWeightForPort["totalvolume"][
                                  totalVolume.toLowerCase()
                                ];

                              if (value > maxValue) {
                                // configStore.setModalMessage(`Length for ${packageType} package should be less than ${shipmentType === 'air' ? 400 : 1190}.`)
                                return `value can't be greater than ${
                                  maxValue + " " + totalVolume
                                } `;
                              }
                            }
                          },
                        }}
                        selectName={`cargoDetails.0.totalVolume.unit`}
                        control={control}
                        name={`cargoDetails.${i}.totalVolume.value`}
                      />
                    </FlexibleCenteredDiv>
                  )}
                  {
                    (cartingStore.disable==false  || cartingStore.update==true) && cargoDetails.length > 1 && (
                      <div
                        onClick={() => {
                          //  const currentType = getValues(`cargoDetails.${i}.packageType`);
                          //  if(currentType==="Loose Cartons"){
                          //      setValue("showPalletLabel",false)
                          //  }

                          removeCargo(i);
                        }}
                        className="w-[35px] h-full flex items-center justify-center cursor-pointer"
                      >
                        <img src={deleteicon} />
                      </div>
                    )
                    // : <CenteredBox sx={{width:"34px"}}/>
                  }
                </div>
              ))}

              <div className="flex flex-row justify-between items-center w-full">
                <div className="flex flex-col ">
     <div className="flex flex-row gap-2.5">
        <p className="text-blue-dark font-bold font-barlow pt-[2.5px]">{mode.toLowerCase()==="lcl"? "Grand" : ""} Total Quantity :</p>
        <TextField
          variant="standard"
          value={isNaN(total.totNumPackages)?0:total.totNumPackages}
          fullWidth={false}
          sx={{
    width: `${String(total.totNumPackages || 0).length + 1}ch`,       
    minWidth: "20px",      
  }}
          InputProps={{
            disableUnderline: true,
            readOnly: false,
             style:{
                color:"#F4B14A",
                fontWeight:"bold",
                fontFamily:"Barlow"
             }
          }}
        />
        {/* <p className="text-yellow font-bold font-barlow">{isNaN(total.totTotalWeight)?0:total.totTotalWeight} Kgs</p> */}
        </div>
     </div>
      <div className="flex flex-col">
           <div className="flex flex-row gap-2.5">
              <p className="text-blue-dark font-bold font-barlow pt-[2.5px]">{mode.toLowerCase()==="lcl" ? "Grand" : ""} Total Weight:</p>
              <TextField
                {...register("grandTotalWeight", { validate:(value)=>{
                  let maxValue = lclWeightForPort.grandtotalweight["kgs"]
                   if(value > maxValue && mode.toLowerCase()==="lcl"){
                      return `value can't be greater than ${maxValue} Kgs.`
                   }
                } })}
                variant="standard"
                value={isNaN(total.totTotalWeight)?0:total.totTotalWeight+ " " +"Kgs"}
                fullWidth={false}
                InputProps={{
                  disableUnderline: true,
                  readOnly: false,
                   style:{
                      color:"#F4B14A",
                      fontWeight:"bold",
                      fontFamily:"Barlow"
                   }
                }}
              />
              {/* <p className="text-yellow font-bold font-barlow">{isNaN(total.totTotalWeight)?0:total.totTotalWeight} Kgs</p> */}
              </div>
              {errors.grandTotalWeight && <p className="text-[#d32f2f] text-sm">{errors.grandTotalWeight.message}</p>}
           </div>
            { !(mode==="air") &&  
                <div className="flex flex-col">
                <div className="flex flex-row gap-2.5">
                   <p className="text-blue-dark font-bold font-barlow pt-[2.5px]">{mode.toLowerCase()==="lcl" ? "Grand" : ""} Total Volume:</p>
                   <TextField
                     {...register("grandTotalVolume", { validate:(value)=>{
                      console.log("the value in volume is ",value)
                       let maxValue = lclWeightForPort.grandtotalvolume["cbm"]
                        if(value > maxValue && mode.toLowerCase()==="lcl"){
                           return `value can't be greater than ${maxValue} CBM.`
                        }
                     } })}
                     variant="standard"
                     value={isNaN(total.totTotalVolume)?0:total.totTotalVolume+ " " +"CBM"}
                     fullWidth={false}
                     InputProps={{
                       disableUnderline: true,
                       readOnly: false,
                        style:{
                           color:"#F4B14A",
                           fontWeight:"bold",
                           fontFamily:"Barlow"
                        }
                     }}
                   />
                   {/* <p className="text-yellow font-bold font-barlow">{isNaN(total.totTotalWeight)?0:total.totTotalWeight} Kgs</p> */}
                   </div>
                   {errors.grandTotalVolume && <p className="text-[#d32f2f] text-sm">{errors.grandTotalVolume.message}</p>}
                </div>
            }
      { mode==="air" &&  
      <div className="flex flex-row gap-2.5"><p className="text-blue-dark font-bold font-barlow">Chargeable Weight:</p><p className="text-yellow font-bold font-barlow">{isNaN(total.totChargeableWeight)?0:total.totChargeableWeight} Kgs</p></div>}
      { (cartingStore.disable==false || cartingStore.update==true) &&
    <button
                onClick={() => {
                  let newCargo = new Cargo();
                  newCargo.totalVolume.unit = totalVolume;
                  newCargo.totalWeight.unit = totalWeight;
                  newCargo.weight.unit = weight;
                  appendCargo({ ...newCargo });
                }}
                type="button"
                className="bg-[#F7F7F7] border-[1px] border-solid border-[#E8E8E8] h-[35px] w-[110px] rounded-[6px]"
              >
                <div className="flex h-full w-full flex-row gap-[5px] justify-center items-center font-bold">
                  <Add
                    sx={{
                      fontSize: "22px",
                      color: process.env.REACT_APP_ENTERPRISE_COLOUR,
                    }}
                  />
                  <p className="text-grey">Add Row</p>
                </div>
              </button>}
    </div>    
            </div>
          </div>
          <hr />
          <div className="flex flex-col w-full rounded-md bg-white shadow-custom p-[18px] gap-[18px]">
            <div className="flex flex-row justify-between items-center">
              <div className="flex flex-row gap-[10px]">
                <img src={cargoDetail} />
                <p className="text-black font-bold">Remarks</p>
              </div>
            </div>
            <div className="columns is-vcentered is-multiline qoutecard">
              <div className="column is-12">
                <textarea
                disabled={cartingStore.disable}
                  ref={ref}
                  value={rsi}
                  onChange={(e) => {
                    setValue("remarks_special_instrctions", e.target.value);
                  }}
                  class="textarea"
                  placeholder="'Remarks / Special instrctions'"
                />
              </div>
            </div>
          </div>
          <hr />
          <div className="columns">
            <$c n="1"></$c>
            <$c n="9">
              <div className="table-container ">
                <table className="table is-fullwidth is-bordered is-striped is-narrow is-hoverable ">
                  <thead>
                    <tr>
                      <th style={{ width: "16rem" }}>Required Documents</th>
                      <th>Document Uploaded</th>
                      {(cartingStore.disable==false || cartingStore.update==true) && <th style={{ width: "12rem" }}></th>}
                    </tr>
                  </thead>
                  <tbody>
                    <tr id="co1">
                      <td>
                        Commercial Invoice{" "}
                      </td>
                      <td
                      >
                        {cartingStore.current.commercialInvoice_filename_list
                          .map(renderLink)
                          .map((link, i) => (
                            <>
                              <p>
                                {link}
                                {(cartingStore.disable==false || cartingStore.update==true) && <span
                                  className="icon has-text-danger"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    cartingStore.current.commercialInvoice_filename_list =
                                      delFile(
                                        cartingStore.current.commercialInvoice_filename_list,
                                        i
                                      );
                                  }}
                                >
                                  <i className="fas fa-trash"></i>
                                </span>}
                              </p>
                              <br />
                            </>
                          ))}
                      </td>
                      {(cartingStore.disable==false || cartingStore.update==true) && <td>
                        <AgCustomFile
                          source="cartingorder"
                          cat={filecat}
                          filetype="commercialInvoice"
                          parent="co1"
                          multi={true}
                          callback={(filename) =>
                            cartingStore.current.commercialInvoice_filename_list.push(filename)
                          }
                          withBtn={
                            cartingStore.current.commercialInvoice_filename_list.length > 0
                          }
                        />
                      </td>}
                    </tr>
                    <tr id="co2">
                      <td>
                        Packing List{" "}
                      </td>
                      <td
                      >
                        {cartingStore.current.packingList_filename_list
                          .map(renderLink)
                          .map((link, i) => (
                            <>
                              <p>
                                {link}
                                {(cartingStore.disable==false || cartingStore.update==true) && <span
                                  className="icon has-text-danger"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    cartingStore.current.packingList_filename_list = delFile(
                                      cartingStore.current.packingList_filename_list,
                                      i
                                    );
                                  }}
                                >
                                  <i className="fas fa-trash"></i>
                                </span>}
                              </p>
                              <br />
                            </>
                          ))}
                      </td>
                      {(cartingStore.disable==false || cartingStore.update==true) && <td>
                        <AgCustomFile
                          source="cartingorder"
                          cat={filecat}
                          filetype="packingList"
                          parent="co2"
                          multi={true}
                          callback={(filename) =>
                            cartingStore.current.packingList_filename_list.push(filename)
                          }
                          withBtn={cartingStore.current.packingList_filename_list.length > 0}
                        />
                      </td>}
                    </tr>
                    <tr id="co3">
                      <td>
                        Shipping Bill{" "}
                      </td>
                      <td
                      >
                        {cartingStore.current.shippingBill_filename_list
                          .map(renderLink)
                          .map((link, i) => (
                            <>
                              <p>
                                {link}
                                {(cartingStore.disable==false || cartingStore.update==true) && <span
                                  className="icon has-text-danger"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    cartingStore.current.shippingBill_filename_list = delFile(
                                      cartingStore.current.shippingBill_filename_list,
                                      i
                                    );
                                  }}
                                >
                                  <i className="fas fa-trash"></i>
                                </span>}
                              </p>
                              <br />
                            </>
                          ))}
                      </td>
                      {(cartingStore.disable==false || cartingStore.update==true) && <td>
                        <AgCustomFile
                          source="cartingorder"
                          cat={filecat}
                          filetype="shippingBill"
                          parent="co3"
                          multi={true}
                          callback={(filename) =>
                            cartingStore.current.shippingBill_filename_list.push(filename)
                          }
                          withBtn={cartingStore.current.shippingBill_filename_list.length > 0}
                        />
                      </td>}
                    </tr>
                    {cartingStore.current.cartingPhotos_filename_list!=undefined && <tr id="co4">
                      <td>
                        Carting photos{" "}
                      </td>
                      <td
                      >
                        {cartingStore.current.cartingPhotos_filename_list
                          .map(renderLink)
                          .map((link, i) => (
                            <>
                              <p>
                                {link}
                                {(cartingStore.disable==false || cartingStore.update==true) && <span
                                  className="icon has-text-danger"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    cartingStore.current.cartingPhotos_filename_list = delFile(
                                      cartingStore.current.cartingPhotos_filename_list,
                                      i
                                    );
                                  }}
                                >
                                  <i className="fas fa-trash"></i>
                                </span>}
                              </p>
                              <br />
                            </>
                          ))}
                      </td>
                      {(cartingStore.disable==false || cartingStore.update==true) && <td>
                        <AgCustomFile
                          source="cartingorder"
                          cat={filecat}
                          filetype="cartingPhotos"
                          parent="co4"
                          multi={true}
                          callback={(filename) =>
                            cartingStore.current.cartingPhotos_filename_list.push(filename)
                          }
                          withBtn={cartingStore.current.cartingPhotos_filename_list.length > 0}
                        />
                      </td>}
                    </tr>}
                    {cartingStore.current.mmSlip_filename_list!=undefined && <tr id="co5">
                      <td>
                        MM Slip{" "}
                      </td>
                      <td
                      >
                        {cartingStore.current.mmSlip_filename_list
                          .map(renderLink)
                          .map((link, i) => (
                            <>
                              <p>
                                {link}
                                {(cartingStore.disable==false || cartingStore.update==true) && <span
                                  className="icon has-text-danger"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    cartingStore.current.mmSlip_filename_list = delFile(
                                      cartingStore.current.mmSlip_filename_list,
                                      i
                                    );
                                  }}
                                >
                                  <i className="fas fa-trash"></i>
                                </span>}
                              </p>
                              <br />
                            </>
                          ))}
                      </td>
                      {(cartingStore.disable==false || cartingStore.update==true) && <td>
                        <AgCustomFile
                          source="cartingorder"
                          cat={filecat}
                          filetype="mmSlip_filename"
                          parent="co5"
                          multi={true}
                          callback={(filename) =>
                            cartingStore.current.mmSlip_filename_list.push(filename)
                          }
                          withBtn={cartingStore.current.mmSlip_filename_list.length > 0}
                        />
                      </td>}
                    </tr>}
                  </tbody>
                </table>
              </div>
            </$c>
          </div>
          {(cartingStore.disable==false || cartingStore.update==true) && <>
          <hr />
          <Columns>
            <Col12>
            
              <div
                className="field is-grouped"
                style={{ display: "flex", justifyContent: "flex-start" }}
              >
                {
                  (cartingStore.update==true)?<div className="control">
                  <button
                    className="button"
                    style={{
                      backgroundColor:
                        process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                      color: "#fff",
                    }}
                    onClick={async (e) => {
                      const isValid = await trigger();
                      setValid(isValid);
                      if (isValid) {
                        handleSubmit(onSubmit)();
                      } else {
                        configStore.setModalMessage(`Please check the fields`);
                      }
                    }}
                  >
                    Update
                  </button>
                </div>:<div className="control">
                  <button
                    className="button"
                    style={{
                      backgroundColor:
                        process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                      color: "#fff",
                    }}
                    onClick={async (e) => {
                      const isValid = await trigger();
                      setValid(isValid);
                      if (isValid) {
                        handleSubmit(onSubmit)();
                      } else {
                        configStore.setModalMessage(`Please check the fields`);
                      }
                    }}
                  >
                    Submit
                  </button>
                </div>
                }
                
                <div className="control">
                  <button
                    class="button is-danger"
                    onClick={() => {
                      AgmodalStore.pageVisible = false;
                      AgmodalStore.apiCall = true;
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Col12>
          </Columns>
          </>}
        </>
      )}
    </>
  );
}
